import options from './get-width.directive';

export default {
    selector: 'getWidth',
    options
};



// WEBPACK FOOTER //
// ./app/common/get-width/index.js